/**
 * Barba
 * Locomotive Scroll
 * Gsap
 * PersleyJS
 * Swiper
 * lightGallery
 * feather
 */

// Styles
import "../sass/main.scss";

// Images.
import "../img/urspelt_logo.svg";
import "../img/urspelt_logo-dark.svg";
import "../img/rosace.svg";
import "../img/fondation-urspelt.svg";
import "../img/acf/au-chateau.svg";
import "../img/acf/chateau-lux.svg";
import "../img/acf/musee.svg";
import "../img/acf/promenade-nature.svg";
import "../img/acf/famille.svg";
import "../img/acf/shopping-magasin.svg";
import "../img/loading.gif";
import "../img/reception-bell.svg";
import "../img/icon-192x192.png";
import "../img/icon-256x256.png";
import "../img/icon-384x384.png";
import "../img/icon-512x512.png";

// Scripts
import "parsleyjs";
// import "magnific-popup";
import lightGallery from "lightgallery";
import barba from "@barba/core";
import Swiper from "swiper/bundle";
import feather from "feather-icons";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import SplitText from "./SplitText.js";
import CustomEase from "./CustomEase.js";
import LocomotiveScroll from "locomotive-scroll";
import Litepicker from "litepicker";
import LazyLoad from "vanilla-lazyload";
import videojs from "video.js";

(function () {
  "use strict";

  // http://stukram.mikhailmasterov.com/html/js/main.js
  // https://codepen.io/mulegoat/project/editor/XvJVNP

  gsap.registerPlugin(ScrollTrigger);

  // GSAP: turn off console warnings
  gsap.config({
    nullTargetWarn: false,
  });

  window.App = {};

  App.config = {
    debug: {
      enabled: false,
    },
    bgmode: {
      light: "#ffffff",
      darken: "#fbf7f2",
      dark: "#101010",
    },
    ajax: {
      enabled: true,
    },
    cursorFollower: {
      enabled: true,
      disableBreakpoint: "992",
    },
    litepicker: {
      selectedDates: [],
    },
    cookies: {
      highlight: "wp-cu-highlight",
    },
  };
  App.litepicker;
  App.html = document.querySelector("html");
  App.body = document.querySelector("body");
  App.select = (e) => document.querySelector(e);
  App.selectAll = (e) => document.querySelectorAll(e);
  App.scroll;

  function appDebug(report1, report2 = null) {
    if (App.config.debug.enabled) {
      if (!report2) {
        //console.log(report1);
      } else {
        console.log(report1, report2);
      }
    }
  }

  window.onload = function () {
    // customEasingsInit();
    pageRevealEffects();
    Preloader.init();

    if (App.config.cursorFollower.enabled) {
      Cursor.init();
    }

    if (App.config.ajax.enabled) {
      PJAX.init();
    }
  };

  function initComponents() {
    //appDebug("initComponents");
    InitFuncSVG();
    setRootVars();
    feather.replace();
    Header.init();
    langageSelector.init();
    checkinoutdates.init();
    mediavideo.init();

    lazyLoading();
    navigationInit();
    splitTextIntoLines();
    mainSlider1Init();
    SliderGallery();
    LGallery();
    InitFuncFormContact();
    // roomsSliderInit();
    RoomsSlider.init();
    NewsSlider.init();
    highlightPanel.init();
    // ringPanelTrigger.init();
  }

  /*--------------------------------------------------
  01. Custom easings
  ---------------------------------------------------*/

  function customEasingsInit() {
    CustomEase.create("quart.out", "0.25, 1, 0.5, 1");
    CustomEase.create("quart.inOut", "0.76, 0, 0.24, 1");
  }

  window.addEventListener("resize", setRootVars, false);
  function setRootVars() {
    let vh = window.innerHeight * 0.01;
    const root = document.documentElement;
    const herovh =
      Math.round(
        document.documentElement.clientHeight || 0,
        window.innerHeight || 0
      ) / 100;
    root.style.setProperty("--herovh", herovh + "px");
  }

  function InitFuncSVG() {
    jQuery("img.svg").each(function () {
      var $img = jQuery(this);
      var imgID = $img.attr("id");
      var imgClass = $img.attr("class");
      var imgURL = $img.attr("src");

      //debug(imgURL);

      jQuery.get(imgURL, function (data) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find("svg");

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr("xmlns:a");
        //$svg = $svg.removeAttr('width');
        //$svg = $svg.removeAttr('height');

        // Replace image with new SVG
        $img.replaceWith($svg);
      });
    });
  }

  /*--------------------------------------------------
    11. Lazy loading
  ---------------------------------------------------*/

  function lazyLoading() {
    if (!document.querySelector(".js-lazy")) {
      return;
    }
    appDebug("lazyLoading");

    function logElementEvent(eventName, element) {
      console.log(Date.now(), eventName, element);
    }
    var callback_error = function (element) {
      logElementEvent("💀 ERROR", element);
      element.src =
        "https://via.placeholder.com/440x560/?text=Error+Placeholder";
    };
    var callback_finish = function () {
      logElementEvent("✔️ FINISHED", document.documentElement);
    };

    new LazyLoad({
      elements_selector: ".js-lazy",
      // Assign the callbacks defined above
      callback_error: callback_error,
      callback_finish: callback_finish,
    });

    // new LazyLoad({
    //   elements_selector: ".js-lazy",
    // });
  }
  function navigationInit() {
    gsap.set(document.querySelector(".menu__shape"), {
      y: "101%",
    });
  }

  function splitTextIntoLines() {
    let target;

    if (App.body.classList.contains("page-reveal-off")) {
      target = document.querySelectorAll(
        "[data-split='lines']:not([data-split-page-reveal])"
      );
    } else {
      target = document.querySelectorAll("[data-split='lines']");
    }

    if (!target.length) return;

    target.forEach((el) => {
      let content;
      let test = el.querySelectorAll("* > *:not(br):not(span)");

      if (test.length > 0) {
        content = el.querySelectorAll("* > *:not(br):not(span)");
      }

      new SplitText(content, {
        type: "lines",
        linesClass: "overflow-hidden",
      });

      content.forEach((el) => {
        const lines = el.querySelectorAll(".overflow-hidden");

        new SplitText(lines, {
          type: "lines",
          linesClass: "split__line",
        });
      });

      gsap.set(el.querySelectorAll(".split__line"), {
        y: "100%",
      });
    });
  }

  /*--------------------------------------------------
  02. Preloader
  ---------------------------------------------------*/
  const Preloader = (function () {
    const preloader = document.querySelector(".js-preloader");
    const bg = preloader.querySelector(".preloader__bg");
    const progress = preloader.querySelector(".preloader__progress");
    const progressInner = preloader.querySelector(
      ".preloader__progress__inner"
    );

    function initial() {
      gsap.registerEffect({
        name: "preloaderInitial",
        effect: (target, config) => {
          document.documentElement.classList.add("html-overflow-hidden");
          const tl = gsap.timeline();

          if (!document.body.classList.contains("preloader-visible")) {
            document.documentElement.classList.remove("html-overflow-hidden");
            return tl;
          }

          return tl
            .fromTo(
              progressInner,
              {
                scaleY: 0,
              },
              {
                scaleY: 1,
                ease: "none",
                duration: 0.3,
                // delay: 0.3,
                onStart: () => {
                  bg.classList.add("origin-top");
                },
              }
            )
            .to(
              progress,
              {
                duration: 0.1,
                ease: "quart.inOut",
                opacity: 0,
                scale: 0.75,
              },
              ">-0.1"
            )
            .to(
              bg,
              {
                ease: "quart.inOut",
                duration: 0.3,
                scaleY: 0,
                onComplete: () => {
                  document.documentElement.classList.remove(
                    "html-overflow-hidden"
                  );
                  appDebug("HOP LA!!!!");
                  App.scroll.update();
                },
              }
              // ">-0.5"
            );
        },
        extendTimeline: true,
      });
    }

    function show() {
      gsap.registerEffect({
        name: "preloaderShow",
        effect: (target, config) => {
          const tl = gsap.timeline();

          if (!preloader) {
            return tl;
          }

          tl.set(progress, {
            opacity: 0,
            scale: 0.75,
          })
            .set(progressInner, {
              scaleY: 0,
            })

            .to(bg, {
              ease: "quart.inOut",
              duration: 0.6,
              scaleY: 1,
              onStart: () => {
                bg.classList.remove("origin-top");
                document.documentElement.classList.add("html-overflow-hidden");
              },
            })
            .to(progress, {
              delay: 0.1,
              duration: 0.6,
              ease: "quart.out",
              opacity: 1,
              scale: 1,
            })
            .to(
              progressInner,
              {
                scaleY: 1,
                duration: 1,
                ease: "none",
              },
              ">-0.3"
            );

          return tl;
        },
        extendTimeline: true,
      });
    }

    function hide() {
      gsap.registerEffect({
        name: "preloaderHide",
        effect: (target, config) => {
          const tl = gsap.timeline();

          return tl
            .to(progress, {
              delay: 0.15,
              duration: 0.5,
              ease: "quart.inOut",
              opacity: 0,
              scale: 0.75,
              onStart: () => {
                bg.classList.add("origin-top");
              },
            })
            .to(
              bg,
              {
                ease: "quart.inOut",
                duration: 1.6,
                scaleY: 0,
                onComplete: () => {
                  document.documentElement.classList.remove(
                    "html-overflow-hidden"
                  );
                  document.documentElement.classList.remove("overflow-hidden");
                  document.body.classList.remove("overflow-hidden");
                  appDebug("HOP LA!!!!");
                  App.scroll.update();
                },
              },
              ">-0.5"
            );
        },
        extendTimeline: true,
      });
    }

    function init() {
      if (!preloader) return;

      initial();
      show();
      hide();
    }

    return {
      init: init,
    };
  })();

  /*--------------------------------------------------
  03. Header
---------------------------------------------------*/

  const Header = (function () {
    let navInner;
    let navBg;
    let navList;
    let navListLinks;
    let navInfoItems;

    let navBtnOpen;
    let navBtnClose;
    let navBack;
    let navLang;

    let menuDeepLevel;
    let timeline = gsap.timeline();

    function updateVars() {
      navInner = document.querySelector(".js-nav-inner");
      navBg = navInner.querySelector(".js-nav-bg");
      navList = navInner.querySelector(".js-navList");
      navListLinks = navInner.querySelectorAll(".js-navList > li > a");
      navInfoItems = navInner.querySelectorAll(".js-navInfo-item");

      navBtnOpen = document.querySelector(".js-nav-open");
      navBtnClose = document.querySelector(".js-nav-close");
      navBack = document.querySelector(".js-nav-back");
      navLang = document.querySelector(".js-nav-lang");

      menuDeepLevel = 0;
    }

    function init() {
      updateVars();
      menuListBindEvents();
      menuAnimBindEvents();
      classicMenuInit();
      headerSticky();
    }

    function deepLevelCheck(level) {
      if (level) {
        gsap.to(navBack, {
          ease: "quart.inOut",
          duration: 0.6,
          y: "0px",
          opacity: 1,
          onStart: () => {
            navBack.classList.remove("pointer-events-none");
          },
        });
      } else {
        gsap.to(navBack, {
          ease: "quart.inOut",
          duration: 0.6,
          opacity: 0,
          onStart: () => {
            navBack.classList.add("pointer-events-none");
          },
        });
      }
    }

    function menuListBindEvents() {
      const listItems = document.querySelectorAll(
        ".js-navList .menu-item-has-children"
      );

      if (!listItems.length) return;

      navBack.addEventListener("click", () => {
        const visibleList = navList.querySelector("ul.is-visible");
        const parentList = visibleList.parentElement.parentElement;

        menuDeepLevel--;

        deepLevelCheck(menuDeepLevel);
        menuListStepAnimate(visibleList, parentList);
      });

      listItems.forEach((el) => {
        const parentLink = el.querySelector("li > a");
        // parentLink.removeAttribute("href");

        parentLink.addEventListener("click", () => {
          const parent = el.parentElement;
          const subnavList = el.lastElementChild;

          menuDeepLevel++;

          deepLevelCheck(menuDeepLevel);
          menuListStepAnimate(parent, subnavList);
        });
      });
    }

    function menuListStepAnimate(hideList, showList) {
      const navBtnClose = document.querySelector(".js-nav-close");

      let hideListItems = hideList.children;
      hideListItems = Array.from(hideListItems);
      const hideListLinks = hideListItems.map((item) =>
        item.querySelector("li > a")
      );

      let showListItems = showList.children;
      showListItems = Array.from(showListItems);
      const showListLinks = showListItems.map((item) =>
        item.querySelector("li > a")
      );

      timeline
        .clear()
        .to(hideListLinks, {
          ease: "quart.out",
          stagger: -0.04,
          duration: 1.0,
          y: "100%",
          onStart: () => {
            showList.classList.add("is-visible");
            hideList.classList.remove("is-visible");
            navBtnClose.classList.add("pointer-events-none");
            navLang.classList.add("pointer-events-none");
          },
        })
        .to(
          showListLinks,
          {
            ease: "quart.out",
            stagger: 0.08,
            duration: 1.2,
            y: "0%",
            onComplete: () => {
              navBtnClose.classList.remove("pointer-events-none");
              navLang.classList.remove("pointer-events-none");
            },
          },
          ">-0.6"
        );
    }

    function menuAnimBindEvents() {
      if (!navBtnOpen) return;

      navBtnOpen.addEventListener("click", () => {
        // if (App.config.headroom.enabled) {
        //   App.headroom.freeze();
        // }

        App.html.classList.add("html-overflow-hidden");
        showMenu();
      });

      navBtnClose.addEventListener("click", () => {
        // if (App.config.headroom.enabled) {
        //   App.headroom.unfreeze();
        // }

        App.html.classList.remove("html-overflow-hidden");
        hideMenu();
      });
    }

    function showMenu() {
      navInner.classList.add("is-active");
      navBtnClose.classList.add("pointer-events-none");
      navLang.classList.add("pointer-events-none");

      gsap
        .timeline()
        .set(navListLinks, { opacity: 1 })
        .set(navBack, { opacity: 0 })

        .fromTo(
          navBg,
          {
            scaleY: 0,
          },
          {
            scaleY: 1,
            duration: 0.8,
            ease: "quart.inOut",
          }
        )
        .fromTo(
          navBtnClose,
          {
            y: "16px",
            opacity: 0,
          },
          {
            ease: "quart.out",
            duration: 0.8,
            y: "0px",
            opacity: 1,
          },
          ">-0.2"
        )
        .fromTo(
          navLang,
          {
            y: "16px",
            opacity: 0,
          },
          {
            ease: "quart.out",
            duration: 0.8,
            y: "0px",
            opacity: 1,
          },
          ">-0.2"
        )
        .fromTo(
          navListLinks,
          {
            y: "100%",
          },
          {
            ease: "quart.out",
            stagger: 0.08,
            duration: 1.2,
            y: "0%",
          },
          ">-0.7"
        )
        .fromTo(
          navInfoItems,
          {
            opacity: 0,
            y: "34px",
          },
          {
            ease: "quart.out",
            stagger: 0.08,
            duration: 1.0,
            opacity: 1,
            y: "0px",
            onComplete: () => {
              navList.classList.add("is-visible");
              navBtnClose.classList.remove("pointer-events-none");
              navLang.classList.remove("pointer-events-none");
            },
          },
          "<"
        );
    }

    function hideMenu() {
      const navVisibleList = navInner.querySelector(".is-visible");
      const navActiveListLinks = navInner.querySelectorAll(
        ".is-visible > li > a"
      );
      menuDeepLevel = 0;

      gsap
        .timeline()
        .to([navBtnClose, navBack, navLang], {
          ease: "quart.out",
          duration: 0.6,
          opacity: 0,
          y: "-16px",
          onStart: () => {
            navBtnClose.classList.add("pointer-events-none");
            navLang.classList.add("pointer-events-none");
            navVisibleList.classList.remove("is-visible");
            navBg.classList.add("origin-top");
          },
        })
        .to(
          navActiveListLinks,
          {
            ease: "quart.out",
            duration: 0.8,
            y: "-100%",
          },
          ">-0.4"
        )
        .to(
          navInfoItems,
          {
            opacity: 0,
            y: "-34px",
            ease: "quart.out",
            duration: 0.8,
          },
          "<"
        )

        .to(
          navBg,
          {
            ease: "quart.inOut",
            duration: 0.8,
            scaleY: 0,
            onComplete: () => {
              navBtnOpen.classList.remove("pointer-events-none");
              navBg.classList.remove("origin-top");
              navInner.classList.remove("is-active");
            },
          },
          ">-0.6"
        );
    }

    function classicMenuInit() {
      const target = document.querySelectorAll(
        ".js-navClassic-list .menu-item-has-children"
      );

      if (!target.length) return;

      const header = document.querySelector(".header");
      let dropDownTheme;

      if (header.classList.contains("js-header-dark")) {
        dropDownTheme = "dark";
      } else {
        dropDownTheme = "light";
      }

      target.forEach((el) => {
        let subnav = el.children;
        let where = "bottom";
        subnav = subnav[subnav.length - 1];

        if (
          el.closest(".menu-item-has-children") &&
          el.closest(".subnav-list")
        ) {
          where = "right";
        }

        tippy(el, {
          interactive: true,
          content: subnav,
          allowHTML: true,
          placement: where,
          offset: [40, 0],
          delay: [null, 200],

          theme: dropDownTheme,
          animation: "shift",

          popperOptions: {
            modifiers: [
              {
                name: "flip",
                options: {
                  fallbackPlacements: ["left-start"],
                },
              },
              {
                name: "preventOverflow",
                options: {
                  altAxis: true,
                },
              },
            ],
          },
        });
      });
    }

    function headerSticky() {
      const header = document.querySelector(".js-header");

      if (!header) return;

      new ScrollMagic.Scene({
        offset: "2px",
      })
        .setClassToggle(header, "is-sticky")
        .addTo(App.SMcontroller);
    }

    return {
      init: init,
    };
  })();

  const checkinoutdates = (function () {
    function initDateRange() {
      const target = document.querySelector(".js-datarange-picker");
      if (!target) return;

      const bookingSubmit = target.querySelector(".booking__submit");

      //appDebug("App.litepicker n'existe pas, on la crée");

      App.litepicker = new Litepicker({
        element: document.getElementById("start-date"),
        elementEnd: document.getElementById("end-date"),
        // parentEl: document.querySelector(".booking__calendar"),
        singleMode: false,
        allowRepick: true,
        position: "left bottom",
        format: "DD-MM-YYYY",
        lang: App.html.lang,
        tooltipText: { one: "jour", other: "jours" },
      });

      App.litepicker.on("selected", (date1, date2) => {
        App.config.litepicker.selectedDates = [date1, date2];
      });
    }
    function setDateRange() {
      if (App.config.litepicker.selectedDates.length) {
        //appDebug("getDateRange!");
        App.litepicker.setDateRange(
          App.config.litepicker.selectedDates[0],
          App.config.litepicker.selectedDates[1],
          true
        );
      }
    }
    function submitDateRange() {
      const bookingSubmit = document.querySelector(".booking__submit");
      if (!bookingSubmit) return;

      bookingSubmit.addEventListener("click", () => {
        //appDebug(App.litepicker.getStartDate());
        //appDebug(App.litepicker.getStartDate().getMonth());
      });
    }

    function init() {
      appDebug("checkinoutdates", "init");
      initDateRange();
      setDateRange();
      submitDateRange();
    }

    function destroy() {
      appDebug("checkinoutdates", "destroy");
      if (App.litepicker) App.litepicker.destroy();
    }
    function hide() {
      if (App.litepicker) App.litepicker.hide();
    }

    return {
      init: init,
      destroy: destroy,
      hide: hide,
    };
  })();

  const langageSelector = (function () {
    let $menuWrapper;

    function animation() {
      appDebug("langageSelector", "animation");
      const $menuItem = document.querySelectorAll(".menu-item");

      for (let i = 0; i < $menuItem.length; i++) {
        const $megamenu = $menuItem[i].querySelector(".sub-menu__wrapper");

        if ($megamenu !== null) {
          $menuItem[i].addEventListener("mouseenter", () => {
            gsap.set($megamenu, {
              height: "auto",
            });
            gsap.from($megamenu, {
              duration: 0.3,
              height: 0,
              ease: "power1.inout",
            });
          });
          $menuItem[i].addEventListener("mouseleave", () => {
            gsap.to($megamenu, {
              duration: 0.3,
              height: 0,
              ease: "power1.inout",
            });
          });
        }
      }
    }
    function init() {
      const lang_params = document.querySelector(".js-nav-lang-params");
      // console.log(lang_params.dataset.pid);
      let data = {
        action: "languageSelector",
        post_ID: lang_params.dataset.pid,
      };
      appDebug("langageSelector", "init");
      $menuWrapper = document.querySelector(".js-nav-lang");
      jQuery.post(ajaxurl, data, function (response) {
        // alert('Got this from the server: ' + response);
        appDebug("langageSelector", response);
        if (response.type == "success" && $menuWrapper !== null) {
          // appDebug("langageSelector", response);
          $menuWrapper.innerHTML = response.message;
          animation();
          feather.replace();
        }
      });
    }

    return {
      init: init,
    };
  })();

  const mediavideo = (function () {
    function init() {
      const target = document.querySelector(".video-js");
      if (!target) return;

      appDebug("mediavideo");

      videojs(target, {
        controls: true,
        autoplay: false,
        preload: "auto",
      });
    }

    return {
      init: init,
    };
  })();

  /*--------------------------------------------------
  04. Page reveals
---------------------------------------------------*/

  function pageRevealEffects() {
    // header, menu and ui elements
    gsap.registerEffect({
      name: "uiElementsAnimate",
      effect: (target, config) => {
        let headerLogo;
        let headerMenu;
        let headerBlogCategories;
        let classicMenu;
        let uiElements;

        if (document.querySelector(".js-header-logo")) {
          headerLogo = document.querySelector(".js-header-logo");
        }
        if (document.querySelector(".js-header-menu")) {
          headerMenu = document.querySelector(".js-header-menu");
        }
        if (document.querySelector(".js-header-blog-categories")) {
          headerBlogCategories = document.querySelector(
            ".js-header-blog-categories"
          );
        }
        if (document.querySelector(".js-navClassic-list > li > a")) {
          classicMenu = document.querySelectorAll(
            ".js-navClassic-list > li > a"
          );
        }
        if (document.querySelector(".js-ui")) {
          uiElements = document.querySelectorAll(".js-ui");
        }

        if (!headerLogo && !headerMenu && !uiElements && !classicMenu) return;

        return gsap.fromTo(
          [
            headerLogo,
            headerMenu,
            headerBlogCategories,
            classicMenu,
            uiElements,
          ],
          {
            y: config.y,
            opacity: 0,
          },
          {
            ease: config.easing,
            duration: config.duration,
            y: "0px",
            opacity: 1,
          }
        );
      },
      extendTimeline: true,
      defaults: {
        easing: "quart.out",
        duration: 0.8,
        y: "30px",
      },
    });

    // masthead background
    gsap.registerEffect({
      name: "mastheadBackground",
      effect: (target, config) => {
        return gsap.fromTo(
          target,
          {
            scale: 1.4,
            opacity: 0,
          },
          {
            ease: "quart.inOut",
            duration: 1.4,
            scale: 1,
            opacity: 1,
          }
        );
      },
      extendTimeline: true,
    });
  }
  const PageReveal = (function () {
    function resetBGMode(tl) {
      tl.to("body", {
        backgroundColor: App.config.bgmode["light"],
        // color: prevText,
        overwrite: "auto",
      });
    }
    function masterHeadFrontpage(tl) {
      const masthead = document.querySelector(".js-masthead-frontpage");

      //appDebug(document.querySelector(".js-masthead-frontpage"));
      if (!masthead) {
        return tl;
      }

      const logo = masthead.querySelector(".js-logo");
      const blogCats = masthead.querySelector(".js-header-blog-categories");
      //const title = masthead.querySelector(".js-content .split__line");
      const content = masthead.querySelectorAll(".js-content .split__line");
      const bgimage = masthead.querySelector(".js-image");

      tl.fromTo(
        bgimage,
        {
          // scale: 1,
          opacity: 0,
        },
        {
          duration: 0.8,
          ease: "quart.inOut",
          // scale: 1.2,
          opacity: 1,
        },
        ">-1.5"
      )
        .fromTo(
          logo,
          {
            opacity: 0,
            y: "34px",
          },
          {
            duration: 1,
            ease: "quart.out",
            opacity: 1,
            y: "0px",
          },
          ">-0.6"
        )
        .fromTo(
          [content, blogCats],
          {
            y: "100%",
          },
          {
            y: "0%",
            stagger: -0.06,
            duration: 0.6,
            ease: "quart.inOut",
            onStart: () => {
              //activeContent.classList.add("is-active");
            },
            onComplete: () => {
              //nav.classList.add("is-active");
            },
          },
          ">-0.2"
        );
    }
    function masterHeadPage(tl) {
      const masthead = document.querySelector(".js-masthead-page");

      //appDebug(document.querySelector(".js-masthead-frontpage"));
      if (!masthead) {
        return tl;
      }

      const logo = masthead.querySelector(".js-logo");
      const blogCats = masthead.querySelector(".js-header-blog-categories");
      //const title = masthead.querySelector(".js-content .split__line");
      const content = masthead.querySelectorAll(".js-content .split__line");
      let bgimage = masthead.querySelector(".js-image");
      const bgimage_night = masthead.querySelector(".js-image-night");
      const bgimage_day = masthead.querySelector(".js-image-day");

      if (bgimage_night && bgimage_day) {
        const d = new Date();
        let hour = d.getHours();
        console.log(hour);
        if (hour < 7 || hour > 20) {
          bgimage = bgimage_night;
          appDebug("Nuit");
        } else {
          bgimage = bgimage_day;
          appDebug("Jour");
        }
      }

      // lazyLoading();

      tl.fromTo(
        bgimage,
        {
          // scale: 1,
          opacity: 0,
        },
        {
          duration: 0.8,
          ease: "quart.inOut",
          // scale: 1.2,
          opacity: 1,
        },
        ">-1.5"
      )
        .fromTo(
          [logo, blogCats],
          {
            opacity: 0,
            y: "34px",
          },
          {
            duration: 1,
            ease: "quart.out",
            opacity: 1,
            y: "0px",
          },
          ">-0.6"
        )
        .fromTo(
          [content],
          {
            y: "100%",
          },
          {
            y: "0%",
            stagger: -0.06,
            duration: 0.6,
            ease: "quart.inOut",
            onStart: () => {
              //activeContent.classList.add("is-active");
            },
            onComplete: () => {
              //nav.classList.add("is-active");
            },
          },
          ">-0.2"
        );
    }

    function highlightPanel(tl) {
      const highlight = document.querySelector(".js-highlight");

      // appDebug(getCookie(App.config.cookies.highlight));
      if (highlight && getCookie(App.config.cookies.highlight) !== undefined) {
        highlight.remove();
        return tl;
      }

      if (!highlight || getCookie(App.config.cookies.highlight) !== undefined) {
        return tl;
      }

      const content = highlight.querySelectorAll(".js-content");
      const button = highlight.querySelectorAll(".js-button");

      tl.fromTo(
        highlight,
        {
          scaleY: 0,
        },
        {
          scaleY: 1,
          duration: 0.8,
          ease: "quart.inOut",
        }
      ).fromTo(
        [content, button],
        {
          opacity: 0,
        },
        {
          opacity: 1,
          stagger: -0.06,
          duration: 0.6,
          ease: "quart.inOut",
          onStart: () => {
            //activeContent.classList.add("is-active");
          },
          onComplete: () => {
            //nav.classList.add("is-active");
            appDebug(highlight);
          },
        },
        ">-0.2"
      );
    }

    function ringPanel(tl) {
      const ringpanel = document.querySelector(".js-ringpanel");
      // appDebug(getCookie(App.config.cookies.highlight));
      if (!ringpanel || getCookie(App.config.cookies.highlight) === undefined) {
        return tl;
      }
      appDebug("HOP ring panel bordel");

      const button = ringpanel.querySelector(".js-ringpanel-bell");

      tl.fromTo(
        button,
        {
          bottom: "0",
        },
        {
          bottom: "100%",
          stagger: -0.06,
          duration: 2.6,
          ease: "quart.inOut",
          onStart: () => {
            //activeContent.classList.add("is-active");
          },
          onComplete: () => {
            //nav.classList.add("is-active");
            appDebug(ringpanel);
            ringPanelTrigger.init();
          },
        },
        ">-0.2"
      );
    }

    function getCookie(cName) {
      const name = cName + "=";
      const cDecoded = decodeURIComponent(document.cookie); //to be careful
      const cArr = cDecoded.split("; ");
      let res;
      cArr.forEach((val) => {
        if (val.indexOf(name) === 0) res = val.substring(name.length);
      });
      return res;
    }

    function init(tl) {
      //appDebug("PageReveal", "init");
      resetBGMode(tl);
      masterHeadFrontpage(tl);
      masterHeadPage(tl);
      highlightPanel(tl);
      ringPanel(tl);

      return tl;
    }
    return {
      init: init,
    };
  })();

  const highlightPanel = (function () {
    function closed() {
      if (getCookie(App.config.cookies.highlight)) {
        return true;
      } else {
        return false;
      }
    }
    function init() {
      const highlight = document.querySelector(".js-highlight");
      // appDebug(getCookie(App.config.cookies.highlight));
      // appDebug(getCookie(App.config.cookies.highlight));
      if (!highlight || getCookie(App.config.cookies.highlight) !== undefined) {
        return;
      }

      const highlightClose = document.querySelector(".js-highlight-close");
      const highlightMore = document.querySelector(".js-highlight-more");

      highlightClose.addEventListener("click", (event) => {
        event.preventDefault();
        closePanel();
      });
      if (highlightMore) {
        highlightMore.addEventListener("click", (event) => {
          closePanel();
        });
      }
    }

    function closePanel() {
      const highlight = document.querySelector(".js-highlight");
      setCookie(App.config.cookies.highlight, "closed", 1);

      gsap.to(highlight, {
        opacity: 0,
        y: "34px",
        duration: 0.2,
        ease: "quart.inOut",
        onStart: () => {},
        onComplete: () => {
          appDebug("Removed the hignlight fini tî!");
          highlight.remove();
        },
      });
    }

    function getCookie(cName) {
      const name = cName + "=";
      const cDecoded = decodeURIComponent(document.cookie); //to be careful
      const cArr = cDecoded.split("; ");
      let res;
      cArr.forEach((val) => {
        if (val.indexOf(name) === 0) res = val.substring(name.length);
      });
      return res;
    }

    function setCookie(cName, cValue, expDays) {
      let date = new Date();
      date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
      const expires = "expires=" + date.toUTCString();
      document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
    }

    return {
      init: init,
      closed: closed,
    };
  })();

  const ringPanelTrigger = (function () {
    function init() {
      const ringpanel = document.querySelector(".js-ringpanel");
      // appDebug("ringPanel", highlightPanel.closed());
      // appDebug(getCookie(App.config.cookies.highlight));
      if (!ringpanel) {
        return;
      }

      const ringpanelContent = ringpanel.querySelector(".js-ringpanel-content");
      const ringpanelBell = ringpanel.querySelector(".js-ringpanel-bell");

      var tl = gsap.timeline({ paused: true });
      tl.to(ringpanelBell, {
        bottom: "0",
        duration: 1.2,
        ease: "quart.inOut",
      });
      tl.to(
        ringpanelContent,
        {
          y: "-100%",
          duration: 1.2,
          ease: "quart.inOut",
        },
        "-=.5"
      );

      const ringpanelTriggers = ringpanel.querySelectorAll(
        ".js-ringpanel-toggle"
      );
      ringpanelTriggers.forEach((el) => {
        el.addEventListener("click", (event) => {
          event.preventDefault();
          if (tl.paused() || tl.reversed()) {
            tl.play();
            appDebug("oufff click !!! PLAY");
          } else {
            tl.reverse();
            appDebug("oufff click !!! REVERSE");
          }
        });
      });
    }

    return {
      init: init,
    };
  })();

  function initialReveal() {
    //appDebug("initialReveal");
    let tl = gsap.timeline();
    tl.preloaderInitial();
    tl = PageReveal.init(tl);
    tl.add(() => {
      // highlight.init(tl);
      // MainSlider3.autoplayStart();
      // mediavideo.init();
      PJAX.initParallax();
    });
  }

  function delay(n) {
    n = n || 2000;
    return new Promise((done) => {
      setTimeout(() => {
        done();
      }, n);
    });
  }

  /*--------------------------------------------------
  05. Custom cursor
---------------------------------------------------*/

  const Cursor = (function () {
    const cursor = document.querySelector(".js-cursor");
    let follower;
    let label;
    let icon;

    let clientX;
    let clientY;
    let cursorWidth;
    let cursorHeight;
    let cursorTriggers;
    let state;

    function variables() {
      follower = cursor.querySelector(".js-follower");
      label = cursor.querySelector(".js-label");
      icon = cursor.querySelector(".js-icon");

      clientX = -100;
      clientY = -100;
      cursorWidth = cursor.offsetWidth / 2;
      cursorHeight = cursor.offsetHeight / 2;
      cursorTriggers;
      state = false;
    }

    function init() {
      if (!cursor) return;

      variables();
      state = true;
      cursor.classList.add("is-enabled");

      document.addEventListener("mousedown", (e) => {
        cursor.classList.add("is-mouse-down");
      });

      document.addEventListener("mouseup", (e) => {
        cursor.classList.remove("is-mouse-down");
      });

      document.addEventListener("mousemove", (event) => {
        clientX = event.clientX;
        clientY = event.clientY;
      });

      const render = () => {
        cursor.style.transform = `translate(${clientX - cursorWidth}px, ${
          clientY - cursorHeight
        }px)`;
        requestAnimationFrame(render);
      };

      requestAnimationFrame(render);

      update();
      breakpoint();
    }

    function enterHandler({ target }) {
      cursor.classList.add("is-active");

      if (target.getAttribute("data-cursor-label")) {
        App.body.classList.add("is-cursor-active");
        cursor.classList.add("has-label");
        label.innerHTML = target.getAttribute("data-cursor-label");
      }

      if (target.getAttribute("data-cursor-icon")) {
        App.body.classList.add("is-cursor-active");
        cursor.classList.add("has-icon");
        const iconAttr = target.getAttribute("data-cursor-icon");
        icon.innerHTML = feather.icons[iconAttr].toSvg();
      }
    }

    function leaveHandler({ target }) {
      //appDebug("leaveHandler");
      App.body.classList.remove("is-cursor-active");
      cursor.classList.remove("is-active");
      cursor.classList.remove("has-label");
      cursor.classList.remove("has-icon");
      label.innerHTML = "";
      icon.innerHTML = "";
    }

    function update() {
      if (!cursor) return;

      cursorTriggers = document.querySelectorAll([
        "button",
        "a",
        "input",
        "[data-cursor]",
        "[data-cursor-label]",
        "[data-cursor-icon]",
        "textarea",
      ]);

      cursorTriggers.forEach((el) => {
        el.addEventListener("mouseenter", enterHandler);
        el.addEventListener("mouseleave", leaveHandler);
        el.addEventListener("click", leaveHandler);
      });
    }

    function clear() {
      if (!cursor) return;
      //appDebug("CLEAR");
      cursorTriggers.forEach((el) => {
        el.removeEventListener("mouseenter", enterHandler);
        el.removeEventListener("mouseleave", leaveHandler);
        el.removeEventListener("click", leaveHandler);
      });
    }

    function hide() {
      if (!cursor) return;
      cursor.classList.add("is-hidden");
    }

    function show() {
      if (!cursor) return;
      cursor.classList.remove("is-hidden");
    }

    function breakpoint() {
      if (!state) return;
      if (!App.config.cursorFollower.disableBreakpoint) return;

      let width = window.innerWidth > 0 ? window.innerWidth : screen.width;

      if (width < App.config.cursorFollower.disableBreakpoint) {
        state = false;
        cursor.classList.remove("is-enabled");
        clear();
      } else {
        state = true;
        cursor.classList.add("is-enabled");
        update();
      }

      window.addEventListener("resize", () => {
        let width = window.innerWidth > 0 ? window.innerWidth : screen.width;

        if (width < App.config.cursorFollower.disableBreakpoint) {
          state = false;
          cursor.classList.remove("is-enabled");
          clear();
        } else {
          state = true;
          cursor.classList.add("is-enabled");
          update();
        }
      });
    }

    return {
      init: init,
      update: update,
      clear: clear,
      hide: hide,
      show: show,
    };
  })();

  /*--------------------------------------------------
  07. Main sliders
---------------------------------------------------*/

  function mainSlider1Init() {
    //appDebug("mainSlider1Init");
    const slider = document.querySelector(".js-sliderMain-type-1");

    if (!slider) return;

    // const nav = slider.querySelector(".js-slider-nav");
    let current = 0;

    const sliderInstance = new Swiper(slider, {
      spaceBetween: 0,
      speed: 1000,
      effect: "fade",
      // parallax: true,
      // grabCursor: true,
      // allowTouchMove: true,
      // touchMoveStopPropagation: true,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      lazy: {
        loadPrevNext: true,
      },

      breakpoints: {
        575: {
          parallax: false,
        },
      },

      // navigation: {
      //   prevEl: nav.querySelector(".js-prev"),
      //   nextEl: nav.querySelector(".js-next"),
      // },
    });
  }

  function SliderGallery() {
    const galleries = document.querySelectorAll(".js-slider-gallery");
    if (!galleries.length) return;

    galleries.forEach((slider) => {
      const swcontainer = slider.querySelector(".swiper-container");
      const pagination = slider.querySelector(".js-slider-pagination");
      const nav = slider.querySelector(".js-slider-navigation");
      let slidesPerView =
        "slidesperview" in swcontainer.dataset
          ? parseInt(swcontainer.dataset.slidesperview)
          : 1.25;
      let spaceBetween =
        "spacebetween" in swcontainer.dataset
          ? parseInt(swcontainer.dataset.spacebetween)
          : 30;

      const sliderInstance = new Swiper(swcontainer, {
        // spaceBetween: 0,
        speed: 1000,
        slidesPerView: 1,
        // centeredSlides: true,
        spaceBetween: 15,
        // effect: "fade",
        // parallax: true,
        // grabCursor: true,
        // allowTouchMove: true,
        // touchMoveStopPropagation: true,
        // autoplay: {
        //   delay: 4500,
        //   disableOnInteraction: false,
        // },
        lazy: {
          loadPrevNext: true,
        },

        breakpoints: {
          580: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          992: {
            slidesPerView: slidesPerView,
            spaceBetween: spaceBetween,
          },
        },

        pagination: {
          el: pagination,
          type: "fraction",
        },
        navigation: {
          prevEl: nav.querySelector(".js-prev"),
          nextEl: nav.querySelector(".js-next"),
        },
      });
    });
  }

  function LGallery() {
    const galleryLinks = document.querySelectorAll(".js-open-lg-gallery");
    if (!galleryLinks.length) return;
    galleryLinks.forEach((el) => {
      el.addEventListener("click", (e) => {
        let params = JSON.parse(e.currentTarget.dataset.params);
        var items = [];
        params.forEach(function (a) {
          items.push({
            src: a.src,
            // title: title,
            subHtml: a.caption,
          });
        });
        // console.log(items);
        /*
        let hash = e.currentTarget.getAttribute("href");
        let parentTarget = document.querySelector(hash);
        let targets = parentTarget.querySelectorAll("figure");
        var items = [];

        if (!targets.length) return;

        targets.forEach((target) => {
          var title = target.querySelector("img").getAttribute("title");
          let alt = target.querySelector("img").getAttribute("alt");
          let caption = target.querySelector("figcaption")
            ? target.querySelector("figcaption").textContent
            : "";
          if (alt) {
            title = alt;
          }
          if (caption) {
            title += "<br /><small>" + caption + "</small>";
          }
          items.push({
            src: target.querySelector("img").src,
            // title: title,
            subHtml: title,
          });
        });
        */

        const dynamicGallery = lightGallery(e.currentTarget, {
          dynamic: true,
          download: false,
          dynamicEl: items,
        });
        dynamicGallery.openGallery();

        e.preventDefault();
      });
    });
  }

  const RoomsSlider = (function () {
    let state = false;
    let sliderInstance;
    let current;

    function init() {
      const slider = document.querySelector(".js-slider-rooms");
      // debug(slider);
      if (!slider) return;

      state = true;

      const swcontainer = slider.querySelector(".swiper-container");
      const contents = slider.querySelectorAll(".js-slider-content");
      const nav = slider.querySelector(".js-slider-nav");
      const pagination = slider.querySelector(".js-slider-pagination");
      current = 0;

      let sliderSpeed = 1000;
      let sliderAutoplay = false;
      let sliderAutoplayStartDelay = 0;

      sliderInstance = new Swiper(swcontainer, {
        spaceBetween: 0,
        speed: parseInt(sliderSpeed),
        centeredSlides: true,
        grabCursor: true,
        autoplay: false,
        lazy: {
          loadPrevNext: true,
        },
        pagination: {
          el: pagination,
          type: "fraction",
        },
        // autoplay: sliderAutoplay,
        // navigation: {
        //   prevEl: nav.querySelector(".slider__arrow_left"),
        //   nextEl: nav.querySelector(".slider__arrow_right"),
        // },
        on: {
          init: function () {
            const currentContent = contents[current];
            // debug("init", currentContent);
            gsap
              .timeline()
              .set(
                [
                  currentContent.querySelectorAll(".js-subtitle .split__line"),
                  currentContent.querySelectorAll(".js-title .split__line"),
                  currentContent.querySelector(".js-desc"),
                  currentContent.querySelector(".js-button"),
                ],
                {
                  y: "0%",
                }
              )
              .set(currentContent.parentNode, {
                height: currentContent.offsetHeight,
                // delay: 2,
              });
          },
          transitionStart: function () {
            const currentContent = contents[current];
            const activeContent = contents[sliderInstance.realIndex];

            //appDebug("transitionStart", activeContent.offsetHeight);

            gsap
              .timeline()
              .to(
                [
                  currentContent.querySelectorAll(".js-subtitle .split__line"),
                  currentContent.querySelectorAll(".js-title .split__line"),
                  currentContent.querySelector(".js-desc"),
                  currentContent.querySelector(".js-button"),
                ],
                {
                  y: "-101%",
                  stagger: 0.06,
                  duration: 0.6,
                  ease: "quart.inOut",
                  onStart: () => {
                    current = sliderInstance.realIndex;
                    currentContent.classList.remove("is-active");
                  },
                }
              )
              .fromTo(
                [
                  activeContent.querySelectorAll(".js-subtitle .split__line"),
                  activeContent.querySelectorAll(".js-title .split__line"),
                  activeContent.querySelector(".js-desc"),
                  activeContent.querySelector(".js-button"),
                ],
                {
                  y: "101%",
                },
                {
                  y: "0%",
                  stagger: -0.06,
                  duration: 0.6,
                  ease: "quart.inOut",
                  onStart: () => {
                    activeContent.classList.add("is-active");
                  },
                  onComplete: () => {
                    // nav.classList.add("is-active");
                  },
                },
                ">-0.2"
              )
              .to(
                activeContent.parentNode,
                {
                  height: activeContent.offsetHeight,
                  duration: 0.3,
                  ease: "quart.inOut",
                  onComplete: () => {
                    //scroll.update();
                  },
                },
                "-=0.3"
              );
          },
        },
      });

      gsap.set(slider.querySelectorAll(".js-desc"), {
        y: "101%",
      });
      gsap.set(slider.querySelectorAll(".js-button"), {
        y: "101%",
      });
    }
    function isActive() {
      return state;
    }
    return {
      init: init,
      isActive: isActive,
    };
  })();

  const NewsSlider = (function () {
    let state = false;
    let sliderInstance;
    let current;

    function init() {
      const slider = document.querySelector(".js-slider-news");
      // debug(slider);
      if (!slider) return;

      state = true;

      const swcontainer = slider.querySelector(".swiper-container");
      current = 0;

      let sliderSpeed = 1000;

      sliderInstance = new Swiper(swcontainer, {
        slidesPerView: 1,
        spaceBetween: 30,
        // speed: parseInt(sliderSpeed),
        // centeredSlides: false,
        //grabCursor: true,
        // autoplay: false,
        lazy: {
          loadPrevNext: true,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        breakpoints: {
          580: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
        // autoplay: sliderAutoplay,
        // navigation: {
        //   prevEl: nav.querySelector(".slider__arrow_left"),
        //   nextEl: nav.querySelector(".slider__arrow_right"),
        // },
      });
    }
    function isActive() {
      return state;
    }
    return {
      init: init,
      isActive: isActive,
    };
  })();

  /*--------------------------------------------------
  17. PJAX
  ---------------------------------------------------*/

  const PJAX = (function () {
    function pageTransitionIn({ container }) {
      // timeline to stretch the loader over the whole screen
      const tl = gsap.timeline().preloaderShow();
      return tl;
    }

    function pageTransitionOut({ container }) {
      checkinoutdates.destroy();
      // timeline to move loader away down
      initComponents();
      let tl = gsap.timeline();
      tl.preloaderHide();
      tl = PageReveal.init(tl);
      tl.add(() => {
        //MainSlider3.autoplayStart();
        if (App.config.cursorFollower.enabled) {
          Cursor.clear();
          Cursor.update();
        }
        // mediavideo.init();
        initParallax();
      });
      return tl;
    }

    function init() {
      if (!document.body.dataset.barba) {
        return;
      }
      barba.hooks.before(() => {
        App.select("html").classList.add("is-transitioning");
        App.scroll.destroy();
      });

      // do something after the transition finishes
      barba.hooks.after(() => {
        App.select("html").classList.remove("is-transitioning");
        // reinit locomotive scroll
        App.scroll.init();

        // Analytics
        if (window.ga && ga.loaded) {
          ga("set", "page", window.location.pathname);
          ga("send", "pageview");
        }
      });

      // scroll to the top of the page
      barba.hooks.enter(() => {
        window.scrollTo(0, 0);
      });

      barba.init({
        sync: true,
        debug: App.config.debug.enabled,
        timeout: 7000,
        transitions: [
          {
            name: "overlay-transition",
            once(data) {
              initComponents();
              // do something once on the initial page load
              initSmoothScroll(data.next.container);
              initialReveal();
              // iniSojernTag(data.next.namespace);
            },
            async leave(data) {
              // animate loading screen in
              pageTransitionIn(data.current);
              await delay(1000);
              data.current.container.remove();
            },
            async enter(data) {
              // animate loading screen away
              pageTransitionOut(data.next);
              // iniSojernTag(data.next.namespace);
            },
            async beforeEnter(data) {
              ScrollTrigger.getAll().forEach((t) => t.kill());
              App.scroll.destroy();
              //appDebug("Destroy Scrol!");
              initSmoothScroll(data.next.container);
            },
          },
        ],
      });
    }

    function removeSojernTag() {
      /**
       * Tags in head
       */
      const allHeadElements = document.querySelectorAll("head > *");
      appDebug("allHeadElements length", allHeadElements.length);
      for (var i = 0; i < allHeadElements.length; i++) {
        //do stuff
      }
      var is_SojernTag = false;
      const allHeadTagNames = new Set(
        [].map.call(allHeadElements, function (el) {
          if (el.id == "sojern") {
            is_SojernTag = true;
          }
          if (is_SojernTag) {
            el.remove();
            appDebug("tag removed", el);
          }

          // console.log(el.id);
          // console.log(el.nodeName);
        })
      );

      /**
       * Tags in body
       */
      const allBodyElements = document.querySelectorAll("body > *");
      appDebug("allBodyElements length", allBodyElements.length);
      const allBodyTagNames = new Set(
        [].map.call(allBodyElements, function (el) {
          if (el.style.display == "none" && el.nodeName == "IMG") {
            appDebug("element removed", el);
            el.remove();
          }
        })
      );
    }

    function iniSojernTag(namespace) {
      appDebug(namespace);
      removeSojernTag();

      switch (namespace) {
        case "home":
          appDebug("sojern tag", "Home page");
          // console.log(document.getElementsByTagName("head")[0].innerHTML);

          var key;
          var params = {};

          /* Please do not modify the below code. */
          var cid = [];
          var paramsArr = [];
          var cidParams = [];
          var pl = document.createElement("script");
          var defaultParams = { vid: "hot" };
          for (key in defaultParams) {
            if (defaultParams.hasOwnProperty(key)) {
              params[key] = defaultParams[key];
            }
          }
          for (key in cidParams) {
            cid.push(params[cidParams[key]]);
          }
          params.cid = cid.join("|");
          for (key in params) {
            paramsArr.push(key + "=" + encodeURIComponent(params[key]));
          }
          pl.type = "text/javascript";
          pl.async = true;
          pl.id = "sojern";
          pl.src =
            "https://beacon.sojern.com/pixel/p/332004?f_v=v6_js&p_v=1&" +
            paramsArr.join("&");
          (
            document.getElementsByTagName("head")[0] ||
            document.getElementsByTagName("body")[0]
          ).appendChild(pl);

          break;
        case "room":
          appDebug("sojern tag", "Rooms");

          /* Please fill the following values. */
          var key;
          var params = {
            hd1: "" /* Check In Date. Format yyyy-mm-dd. Ex: 2015-02-14 */,
            hd2: "" /* Check Out Date. Format yyyy-mm-dd. Ex: 2015-02-14 */,
            hc1: "" /* Destination City */,
            hs1: "" /* Destination State or Region */,
            hr: "" /* Number of Rooms */,
            t: "" /* Number of Travelers */,
          };

          /* Please do not modify the below code. */
          var cid = [];
          var paramsArr = [];
          var cidParams = [];
          var pl = document.createElement("script");
          var defaultParams = { vid: "hot", et: "hpr" };
          for (key in defaultParams) {
            params[key] = defaultParams[key];
          }
          for (key in cidParams) {
            cid.push(params[cidParams[key]]);
          }
          params.cid = cid.join("|");
          for (key in params) {
            paramsArr.push(key + "=" + encodeURIComponent(params[key]));
          }
          pl.type = "text/javascript";
          pl.async = true;
          pl.id = "sojern";
          pl.src =
            "https://beacon.sojern.com/pixel/p/332007?f_v=v6_js&p_v=1&" +
            paramsArr.join("&");
          (
            document.getElementsByTagName("head")[0] ||
            document.getElementsByTagName("body")[0]
          ).appendChild(pl);

          break;
        default:
          appDebug("sojern tag", "All pages not home and not rooms");
          var key;
          var params = {};

          /* Please do not modify the below code. */
          var cid = [];
          var paramsArr = [];
          var cidParams = [];
          var pl = document.createElement("script");
          var defaultParams = { vid: "hot" };
          for (key in defaultParams) {
            params[key] = defaultParams[key];
          }
          for (key in cidParams) {
            cid.push(params[cidParams[key]]);
          }
          params.cid = cid.join("|");
          for (key in params) {
            paramsArr.push(key + "=" + encodeURIComponent(params[key]));
          }
          pl.type = "text/javascript";
          pl.async = true;
          pl.id = "sojern";
          pl.src =
            "https://beacon.sojern.com/pixel/p/332005?f_v=v6_js&p_v=1&" +
            paramsArr.join("&");
          (
            document.getElementsByTagName("head")[0] ||
            document.getElementsByTagName("body")[0]
          ).appendChild(pl);
      }
    }

    function initSmoothScroll(container) {
      //appDebug("Init! Scrol!");
      App.scroll = new LocomotiveScroll({
        el: container.querySelector("[data-scroll-container]"),
        smooth: false,
        getDirection: true,
        reloadOnContextChange: true,
        repeat: true,
        //getDirection: true
        smartphone: {
          smooth: false,
        },
        tablet: {
          smooth: false,
        },
      });

      App.scroll.on("scroll", ScrollTrigger.update);

      ScrollTrigger.scrollerProxy("[data-scroll-container]", {
        scrollTop(value) {
          return arguments.length
            ? App.scroll.scrollTo(value, 0, 0)
            : App.scroll.scroll.instance.scroll.y;
        }, // we don't have to define a scrollLeft because we're only scrolling vertically.
        getBoundingClientRect() {
          return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight,
          };
        },
        // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
        pinType: container.querySelector("[data-scroll-container]").style
          .transform
          ? "transform"
          : "fixed",
      });

      /**
       * Background
       */

      const scrollColorElems = container.querySelectorAll("[data-bgmode]");
      var darkModeStatus = false;
      scrollColorElems.forEach((colorSection, i) => {
        const prevBg = i === 0 ? "" : scrollColorElems[i - 1].dataset.bgcolor;
        const prevText =
          i === 0 ? "" : scrollColorElems[i - 1].dataset.textcolor;
        const prevMode = i === 0 ? "" : scrollColorElems[i - 1].dataset.bgmode;
        const prevID =
          i === 0 ? "" : scrollColorElems[i - 1].getAttribute("id");

        ScrollTrigger.create({
          trigger: colorSection,
          scroller: "[data-scroll-container]",
          start: "top 50%",
          // markers: true,
          onEnter: function () {
            //appDebug(colorSection.dataset.bgmode);
            if (colorSection.dataset.bgmode == "dark") {
              container.classList.add("is-dark");
              gsap.to(document.querySelector(".masterLogo #logo"), {
                duration: 0.2,
                fill: "#fff",
                overwrite: "auto",
              });
            } else {
              container.classList.remove("is-dark");
              gsap.to(document.querySelector(".masterLogo #logo"), {
                duration: 0.2,
                fill: "#414141",
                overwrite: "auto",
              });
            }
            // setDarkModeBG(colorSection.dataset.darkmode);
            // showMenu(colorSection.getAttribute("id"));
            gsap.to("body", {
              duration: 0.5,
              backgroundColor: App.config.bgmode[colorSection.dataset.bgmode],
              // color: colorSection.dataset.textcolor,
              overwrite: "auto",
            });
          },
          onLeaveBack: function () {
            if (prevMode == "dark") {
              container.classList.add("is-dark");
              gsap.to(document.querySelector(".masterLogo #logo"), {
                duration: 0.2,
                fill: "#fff",
                overwrite: "auto",
              });
            } else {
              container.classList.remove("is-dark");
              gsap.to(document.querySelector(".masterLogo #logo"), {
                duration: 0.2,
                fill: "#414141",
                overwrite: "auto",
              });
            }
            // setDarkModeBG(prevMode);
            // showMenu(prevID);
            //appDebug(prevMode);
            gsap.to("body", {
              duration: 0.5,
              backgroundColor: App.config.bgmode[prevMode],
              // color: prevText,
              overwrite: "auto",
            });
          },
        });
      });

      ScrollTrigger.create({
        trigger: container.querySelector(".masterhead"),
        start: "111px",
        // end: "100px top",
        // markers: true,
        scroller: "[data-scroll-container]",
        onEnter: function () {
          gsap.fromTo(
            document.querySelector(".menu__shape"),
            {
              y: "-101%",
            },
            {
              duration: 0.2,
              y: "0",
            }
          );
          gsap.to(document.querySelector(".masterMenu__bar"), {
            duration: 0.2,
            color: "#414141",
          });
          gsap.to(document.querySelector(".masterMenu__divider"), {
            duration: 0.2,
            backgroundColor: "#414141",
          });
          gsap.to(document.querySelector(".masterMenu"), {
            duration: 0.2,
            boxShadow: "0px 0px 35px -25px rgba(0,0,0,.75)",
          });
        },
        onLeaveBack: function () {
          gsap.to(document.querySelector(".menu__shape"), {
            duration: 0.2,
            y: "101%",
          });
          gsap.to(document.querySelector(".masterMenu__bar"), {
            duration: 0.2,
            color: "#fff",
          });
          gsap.to(document.querySelector(".masterMenu__divider"), {
            duration: 0.2,
            backgroundColor: "#fff",
          });
          gsap.to(document.querySelector(".masterMenu"), {
            duration: 0.2,
            boxShadow: "0px 0px 35px -25px rgba(0,0,0,0)",
          });
          gsap.to(document.querySelector(".masterMenu"), {
            duration: 0.2,
            boxShadow: "0px 0px 35px -25px rgba(0,0,0,0)",
          });
        },
        //markers:true
      });

      ScrollTrigger.create({
        trigger: container.querySelector(".masterhead"),
        start: "100%",
        // end: "200px top",
        // markers: true,
        scroller: "[data-scroll-container]",
        onEnter: function () {
          gsap.to(document.querySelector(".masterLogo"), {
            duration: 0.2,
            opacity: 1,
          });
          gsap.to(document.querySelector(".masterLogo #logo"), {
            duration: 0.2,
            fill: "#414141",
          });
        },
        onLeaveBack: function () {
          gsap.to(document.querySelector(".masterLogo"), {
            duration: 0.2,
            opacity: 0,
          });
          gsap.to(document.querySelector(".masterLogo #logo"), {
            duration: 0.2,
            fill: "#fff",
          });
        },
        //markers:true
      });

      /**
       * Remove Old Locomotive Scrollbar
       */

      const scrollbar = App.selectAll(".c-scrollbar");

      if (scrollbar.length > 1) {
        scrollbar[0].remove();
      }

      // each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll.
      ScrollTrigger.addEventListener("refresh", () => App.scroll.update());

      // after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
      ScrollTrigger.refresh();
    }

    function initParallax() {
      //appDebug("initParallax");

      gsap.utils.toArray(".is-header-parallax").forEach((section) => {
        // get the image
        const image = section.querySelector("img");

        //appDebug("initImageParallax", image);
        // create tween for the image

        gsap.to(image, {
          scaleX: 1.1,
          scaleY: 1.1,
          // opacity: 0.7,
          ease: "power2.inOut",
          scrollTrigger: {
            trigger: section,
            // markers: true,
            scroller: ".scroll-container",
            start: "bottom bottom",
            scrub: 0.5,
          },
        });
      });

      // select all sections .with-parallax
      gsap.utils.toArray(".is-parallax").forEach((section) => {
        // get the image
        const image = section.querySelector("img");
        // const image = section.querySelector("img");

        //appDebug("initImageParallax", image);
        // create tween for the image

        gsap.to(image, {
          scaleX: 1.1,
          scaleY: 1.1,
          ease: "power2.inOut",
          scrollTrigger: {
            trigger: section,
            scroller: ".scroll-container",
            start: "top bottom",
            scrub: 0.5,
          },
        });
      });
    }

    return {
      init: init,
      initParallax: initParallax,
    };
  })();

  function InitFuncFormContact() {
    const datetablebooking = document.querySelector(
      ".js-datetablebooking-picker"
    );
    if (datetablebooking) {
      var timeelement = document.getElementById("booking-time");
      var today = new Date();
      var date =
        today.getDate() +
        "-" +
        addZ(today.getMonth() + 1) +
        "-" +
        today.getFullYear();

      console.log(date);

      function addZ(n) {
        return n < 10 ? "0" + n : "" + n;
      }

      App.litepicker = new Litepicker({
        element: document.getElementById("booking-date"),
        // parentEl: document.querySelector(".booking__calendar"),
        singleMode: true,
        allowRepick: true,
        position: "left bottom",
        format: "DD-MM-YYYY",
        minDate: today.setDate(today.getDate()),
        lang: App.html.lang,
        tooltipText: { one: "jour", other: "jours" },
      });

      App.litepicker.setDate(date, true);

      timeelement.value = today.getHours() + ":" + today.getMinutes();
    }

    jQuery("#contact-form").parsley();
    jQuery("#contact-form").on("submit", function (e) {
      e.preventDefault();
      var t = jQuery(this),
        o = t.find("#valid-form");
      t.parsley().validate(),
        (o.disabled = !0),
        (o.innerText = "Envoi..."),
        t.parsley().isValid() &&
          jQuery.ajax({
            url: ajaxurl,
            data: jQuery(this).serialize(),
            type: "POST",
            success: function (e) {
              appDebug(e),
                jQuery(".fields").fadeOut(200),
                setTimeout(function () {
                  jQuery(".messages")
                    .addClass("alert alert-success")
                    .html(e.message)
                    .fadeIn();
                }, 225),
                setTimeout(function () {
                  jQuery(".messages").fadeIn();
                }, 300);
            },
            error: function (e) {
              appDebug(e);
              jQuery(".fields").fadeOut(200),
                setTimeout(function () {
                  jQuery(".messages")
                    .addClass("alert alert-danger")
                    .html(e.message)
                    .fadeIn();
                }, 225),
                setTimeout(function () {
                  jQuery(".sub_error").css("opacity", "1");
                }, 300);
            },
          });
    });
  }

  Parsley.addMessages("fr", {
    defaultMessage: "Cette valeur semble non valide.",
    type: {
      email: "Cette valeur n'est pas une adresse email valide.",
      url: "Cette valeur n'est pas une URL valide.",
      number: "Cette valeur doit être un nombre.",
      integer: "Cette valeur doit être un entier.",
      digits: "Cette valeur doit être numérique.",
      alphanum: "Cette valeur doit être alphanumérique.",
    },
    notblank: "Cette valeur ne peut pas être vide.",
    required: "Ce champ est requis.",
    pattern: "Cette valeur semble non valide.",
    min: "Cette valeur ne doit pas être inférieure Ã  %s.",
    max: "Cette valeur ne doit pas excéder %s.",
    range: "Cette valeur doit être comprise entre %s et %s.",
    minlength:
      "Cette chaîne est trop courte. Elle doit avoir au minimum %s caractères.",
    maxlength:
      "Cette chaîne est trop longue. Elle doit avoir au maximum %s caractères.",
    length: "Cette valeur doit contenir entre %s et %s caractères.",
    mincheck: "Vous devez sélectionner au moins %s choix.",
    maxcheck: "Vous devez sélectionner %s choix maximum.",
    check: "Vous devez sélectionner entre %s et %s choix.",
    equalto: "Cette valeur devrait être identique.",
  });

  Parsley.setLocale("fr");

  /**
   * Magnific Popup Translations
   
  function getCookie(cName) {
    const name = cName + "=";
    const cDecoded = decodeURIComponent(document.cookie); //to be careful
    const cArr = cDecoded.split("; ");
    let res;
    cArr.forEach((val) => {
      if (val.indexOf(name) === 0) res = val.substring(name.length);
    });
    return res;
  }
  
  */
})();
